import { v4 as uuid } from 'uuid';

import {
  BlockFragment,
  SectionFragment,
} from '__generated__/queries-newsletter';

export interface CreateSections extends SectionFragment {
  isCreate: boolean;
  maxBlocksAmount?: number;
}

export interface CreateBlocks extends BlockFragment {
  isCreate: boolean;
}

export const emptySection = (
  position: number,
  maxBlocksAmount?: number,
): CreateSections => ({
  __typename: 'Section',
  id: uuid(),
  title: null,
  position,
  url: '',
  createdAt: '',
  updatedAt: '',
  blocks: [],
  isCreate: true,
  maxBlocksAmount,
});

export const emptyBlock = ({
  title,
  url,
  body = null,
  blockType = '',
  surTitle,
  media,
  position,
  isAutoPromo = false,
  linkLabel,
  content,
}: {
  title?: string | null;
  url?: string | null;
  urlInError?: boolean;
  urlInErrorMessage?: string;
  body?: string | null;
  blockType?: string;
  surTitle?: string | null;
  media?: any;
  position: number | null;
  isAutoPromo?: boolean | null;
  linkLabel?: string | null;
  content?: string | null;
}): CreateBlocks => ({
  __typename: 'Block',
  id: uuid(),
  title: title || null,
  content: content || null,
  position,
  surTitle: surTitle || null,
  leadIn: false,
  url: url || null,
  linkLabel: linkLabel || null,
  rawMedia: '',
  createdAt: '',
  updatedAt: '',
  media,
  isAutoPromo,
  blockType,
  isCreate: true,
  body,
});

export const emptyCampaign = () => ({
  sections: [],
  newsletter: { name: '' },
});
